import React, { useEffect, useState } from 'react';
import ItemScores from './ScoreItem'
import { Scrollbar } from "react-scrollbars-custom";

const ScoreBox = (props) => {
    return (
        <div className="scorebox">
            <Scrollbar
                style={{ width: 100 + '%', height: 400 }}>
                <div className="box-body">
                    {props.data.length == 0 ?
                        <span className="no-content">موردی برای نمایش وجود ندارد.</span>
                        :
                        props.data.map(info =>
                            <ItemScores
                                title={info.title}
                                date={info.string_date}
                                grade={info.score}
                                lose={props.lose}
                            />
                        )}
                </div>
            </Scrollbar>
        </div>
    );
}

export default ScoreBox;